import Content from '../../content.js';

namespace('IO.Views.Users', function (exports) {
  'use strict';

  var FormView = exports.New,
    ShellUser = exports.ShellUser.New,
    Show = Content.extend({
      dom: {
        SHELL_ACCESS_VALUE: '.shell-access',
        SHELL_ACCOUNT: '.shell-account',
        SHELL_ACCOUNT_CONTAINER: '.shell-account-container',
        SELECT2_INITIALIZED: '.select2-container',
        USER_GROUPS_FIELD: '.user_groups',
      },

      events: {
        'change .check-all': '_toogleAbilities',
      },

      afterRender: function () {
        var self = this;

        if (this.$(this.dom.SHELL_ACCOUNT_CONTAINER).length) {
          this.shellUser = new ShellUser();
          this.shellUser.reload(function () {
            self.subview();
          });
        }
        this.subview();
      },

      beforeRender: function () {
        this.roleRetrieval = new UserRoleRetrieval();
        this.primaryCustomerRetrieval = new PrimaryCustomerRetrieval();
      },

      subview: function () {
        var $userGroupField = this.$el.find(this.dom.USER_GROUPS_FIELD);

        if ($userGroupField.length > 0) {
          $userGroupField.select2({ minimumInputLength: 1 });
        }

        this.form = new FormView();
        this._preSelect();
      },

      error: function () {
        this.form.error();
      },

      _preSelect: function () {
        $('.capability-box').each(function (i, box) {
          var selected = true;

          $(box)
            .find('ul input')
            .each(function (x, item) {
              if (!$(item).is(':checked')) {
                selected = false;
              }
            });
          $(box).find('.check-all').attr('checked', selected);
        });
      },

      _toogleAbilities: function (e) {
        var checked = $(e.target).is(':checked');

        $(e.target).next().toggleClass('checked', checked);
        $(e.target)
          .parents('.capability-box')
          .find('ul input')
          .each(function (i, item) {
            $(item)
              .prop('checked', checked)
              .next()
              .toggleClass('checked', checked);
          });
      },

      _modalCreated: function (args) {
        var $modal = args[1],
          modalId = $modal[0].id,
          $userGroupField = $modal.find(this.dom.USER_GROUPS_FIELD),
          tags;

        if (modalId.indexOf('shell') === -1) {
          if (!this.form) {
            this.form = new FormView({ el: '#' + $modal[0].id });
          } else {
            this.form.render();
          }
        } else if (
          !$modal.find(this.dom.SELECT2_INITIALIZED).length &&
          $userGroupField.length
        ) {
          tags = $userGroupField.data('tags').split(',') || [];
          $userGroupField.select2({ minimumInputLength: 1, tags: tags });
        }
      },
    });

  exports.Show = Show;
});
